/**
 * Familles de types de projet — définition UNIQUE.
 *
 * Pourquoi ce fichier existe : ces deux listes étaient recopiées à la main
 * dans `fiche-projet.ts` (côté serveur) et dans `ProjectDetail.tsx` (côté
 * navigateur). Elles ne décident pourtant pas de la même chose :
 *   - côté serveur, `AGRI_TYPES` décide si les leviers agricoles sont CALCULÉS ;
 *   - côté navigateur, la même liste décide si la section « Leviers agricoles »
 *     est AFFICHÉE.
 * Le jour où un type n'est ajouté qu'à l'une des deux, la section disparaît
 * sans erreur, sans journal et sans trace — ou bien on calcule des leviers que
 * personne n'affiche. Une seule liste, importée des deux côtés, rend cette
 * dérive impossible (revue `perf/blog-allege`, constat I-5).
 *
 * Ce module ne contient AUCUNE donnée de catalogue et n'importe rien : il peut
 * donc être importé depuis un composant `'use client'` sans embarquer le
 * moindre JSON dans le paquet du navigateur.
 */

/** Types de projet agricoles (ceux qui ont des leviers agricoles). */
export const AGRI_TYPES: readonly string[] = [
  'grandes_cultures',
  'carbon_agri',
  'vergers',
  'haies',
  'reduction_intrants',
  'elevage',
]

/** Types de projet forestiers (ceux qui ont des essences plantées). */
export const FORESTRY_TYPES: readonly string[] = ['boisement', 'reboisement', 'belle_foret']

export const estAgricole = (type: string): boolean => AGRI_TYPES.includes(type)
export const estForestier = (type: string): boolean => FORESTRY_TYPES.includes(type)
